/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface TenantOrgCapabilitiesDeployments { 
    allow_any_version?: boolean;
    /**
     * Allow import of deployments into service plane.
     */
    allow_import?: boolean;
    /**
     * Allow tenant to reconfigure IRR.
     */
    allow_tenant_reconfigure?: boolean;
    degree_of_parallelism?: number;
}

